import {
  REQUEST_PAYMENTS,
  RECEIVE_PAYMENTS
} from 'actions'

export default function paymentsByWorkspaceSlug (state = initialState(), action) {
  const { type, payload } = action
  switch (type) {
    case REQUEST_PAYMENTS:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...initialState(),
            ...state.data[payload.slug],
            isRequesting: true,
            didRequestFail: false
          }
        }
      }
    case RECEIVE_PAYMENTS:
      return {
        ...state,
        hasRequested: true,
        data: {
          ...state.data,
          [payload.slug]: {
            ...initialState(),
            hasRequested: true,
            data: payload.data
          }
        }
      }
    default:
      return state
  }
}

/**
 * Initial state.
 */

function initialState () {
  return {
    isRequesting: false,
    didRequestFail: false,
    hasRequested: false,
    didInvalidate: false,
    data: {}
  }
}



// WEBPACK FOOTER //
// ./reducers/payments.js